import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderOption} from '../../../model/order-option';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {PageNames} from '../../../shared/page-names.enum';
import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {PriceUtils} from '../../../shared/utils/price/price.utils';
import {Order} from '../../../model/order';
import {LanguageService} from '../../../services/language/language.service';
import {ResourceService} from '../../../services/resource/resource.service';
import {Environment} from '../../../shared/environment/environment';
import {TvshopConstants} from '../../../shared/tvshop-constants';
import {OmapiIdConstants} from '../../../shared/omapi-id-constants';
import {PriceDetail} from '../../../model/ocapi/price-detail';

@Component({
  selector: 'app-product-order-option',
  templateUrl: './product-order-option.component.html',
  styleUrls: ['./product-order-option.component.less']
})
export class ProductOrderOptionComponent implements OnInit {
  ownerComponent = PageNames.DETAIL_PAGE_ORDER_OPTIONS;
  @Input()
  x: number;
  @Input()
  y: number;
  @Input()
  isDayPass: boolean;
  @Input()
  isTrial: boolean;
  @Input()
  omapiId: string;
  @Input()
  pack: TvShopEntertainmentPack;
  @Input()
  orderOption: OrderOption;
  @Input()
  hasOverlayMessage: boolean;
  @Output()
  emitOrderProduct = new EventEmitter<Object>();
  @Output()
  emitOrderTrial = new EventEmitter<Object>();

  active: boolean;

  name: string;
  label = 'eos-tv-shop-ii.title.play-sports-details-order-options-order';

  priceDetail: PriceDetail;

  constructor(private navigationService: NavigationService,
              private languageService: LanguageService,
              private resourceService: ResourceService) {
  }

  ngOnInit(): void {
    this.setLabel();
    this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
  }

  private setLabel() {
    if (this.isDayPass) {
      this.label = 'eos-tv-shop-ii.title.play-sports-details-order-options-order-daypass';
    } else if (this.isTrial) {
      this.label = 'eos-tv-shop-ii.btn.trial-order';
    }
  }

  public getLogoUrl(): string {
    if (this.orderOption && !this.orderOption.isTrial) {
      return this.resourceService.getLogoUrl(this.orderOption.omapiId, undefined, this.orderOption.isDayPass);
    } else {
      return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdConstants.TRIALS + '-logo.png';
    }
  }

  activate(active: boolean): void {
    this.active = active;
  }

  get hasPromo(): boolean {
    return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromo();
  }

  get hasPromoDayPass(): boolean {
    return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromoLessThanAMonth();
  }

  get isPromoSamePrice(): boolean {
    return this.orderOption.priceDetail.price.value === this.orderOption.priceDetail.promoPrice.value;
  }

  get promoLabel(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoLabel : undefined;
  }

  get promoDuration(): number {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoDuration : undefined;
  }

  get textIntegerPart(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.price.integerPart() : undefined;
  }

  get textDecimalPart(): string {
    return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
  }

  get priceBeforeComma(): string {
    return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.integerPart() : undefined;
  }

  get getPriceTextDecimalPart(): string {
    return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.decimalPart() : undefined);
  }

  public onEmitOrderProduct(event: Order): void {
    this.emitOrderProduct.emit(event);
  }

  onBack(): void {
    this.navigationService.resetPage();
  }

  get getCurrentLang(): string {
    return this.languageService.getCurrentLanguage().toLowerCase();
  }

  onEmitOrderTrial($event: Order) {
    this.emitOrderTrial.emit(event);
  }

  get hideButton(): boolean {
    return this.hasOverlayMessage && (this.isTrial || this.isDayPass);
  }

  private getTextDecimalPart(price: string): string {
    const sign = this.getCurrentLang === 'fr' ? ' €' : '';
    return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
  }
}
